module.exports = __webpack_public_path__ + "static/duckie-c2b244707830af1b20360c5f0f3fd942.jpg";